module.exports = __webpack_public_path__ + "static/img/5areaA_13.0626f91.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/5areaA_13.png
// module id = 813
// module chunks = 1